/**
 * @generated SignedSource<<cfbfe116b62c44560bfecf76fa5e50cc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSponsoredItemsTracking_metadata$data = ReadonlyArray<{
  readonly clickTrackerLink: string | null;
  readonly impressionTrackerLink: string | null;
  readonly itemId: string | null;
  readonly " $fragmentType": "useSponsoredItemsTracking_metadata";
}>;
export type useSponsoredItemsTracking_metadata$key = ReadonlyArray<{
  readonly " $data"?: useSponsoredItemsTracking_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSponsoredItemsTracking_metadata">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useSponsoredItemsTracking_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impressionTrackerLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clickTrackerLink",
      "storageKey": null
    }
  ],
  "type": "SponsoredItemsMetadata",
  "abstractKey": null
};

(node as any).hash = "7701a2561359d2ae4431f68a0af33720";

export default node;
